export class Doctor {
  readonly id!: number;
  readonly midname!: string;
  readonly name!: string;
  readonly surname!: string;

  get fullName(): string {
    return [this.name, this.midname, this.surname].filter(Boolean).join(' ');
  }

  /** Фамилия и инициалы (например, «Тыртов Д. И.») */
  get surnameAndInitials(): string {
    const parts: string[] = [this.surname].filter(Boolean);
    if (this.name) parts.push(`${this.name.charAt(0)}.`);
    if (this.midname) parts.push(`${this.midname.charAt(0)}.`);
    return parts.join(' ') || this.fullName;
  }
}
